import React,{useContext} from 'react'
import { GlobalContext } from '../contexts/GlobalContext'
import LoadingIcons from 'react-loading-icons'
import { useEffect } from 'react'

const SubmitButton = ({name,onSubmit, width,disabled,loading}) => {

  return (
    <button onClick={(e) => {!loading && onSubmit && onSubmit(e)}} 
		type="submit"
        disabled={disabled || loading}
        style={{width:width + 'px' || '100%'}}
        className={`flex h-8 rounded-lg items-center justify-center shrink-0 font-light ${disabled || loading?'bg-themeMedium':'bg-theme'} text-white hover:bg-themeMedium shadow-md overflow-hidden`}>
        {loading?<LoadingIcons.Oval width={24} height={24}/>
        :
        <p className='w-full overflow-hidden overflow-ellipsis'>{name?name:'Submit'}</p>}
    </button>
  )
}

export default SubmitButton